import { createFileRoute } from '@tanstack/react-router'
import { AdminNotificationsPage } from '@/features/admin/notifications'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/notifications/')({
  component: AdminNotificationsPage,
  beforeLoad: requireRole(['admin']),
})
